import script from "./EditOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./EditOrganization.vue?vue&type=script&setup=true&lang=js"

import "./EditOrganization.vue?vue&type=style&index=0&id=a708185c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a708185c"]])

export default __exports__